import { LoginService } from './../../shared/service/login/login.service';
import { Component, OnInit } from '@angular/core';
import { Usuario } from '../../shared/model/usuario';
import { UsuarioService } from '../../shared/service/usuario/usuario.service';
import { environment } from '../../../environments/environment';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { UtilService } from '../../shared/service/util/util.service';

export interface FormModel {
  captcha?: string;
}

@Component({
  selector: 'app-novo-cadastro',
  templateUrl: './novo-cadastro.component.html',
  styleUrls: ['./novo-cadastro.component.css']
})
export class NovoCadastroComponent implements OnInit {

  public usuario = new Usuario();
  public error: boolean = false;
  public captchaValue: string;
  public recaptchaSiteKey: string;
  public regex: string;
  public showSpinner: boolean = false;

  constructor(
    private usuarioService: UsuarioService,
    private location: Location,
    private utilService: UtilService,
    private loginService: LoginService,
    private router: Router) {

    let urlAcesso = this.utilService.getSubdominio();

    if (urlAcesso == "") {
      this.utilService.showError("Página não está disponível para o contexto Varejo.");
      this.router.navigate(['/login']);
    }
  }

  ngOnInit() {
    this.recaptchaSiteKey = environment.recaptchaSiteKey;
    this.regex = '^[a-zA-Z]+ [a-zA-Z].+';
    this.captchaValue = "";
  }

  salvar() {
    this.showSpinner = true;
    this.usuario.urlAcesso = this.utilService.getSubdominio();
    
    this.usuarioService.cadastrarNovoUsuarioCorporativo(this.usuario).subscribe(
      () => {
        this.utilService.showSuccess("Cadastro efetuado com sucesso. Verifique seu e-mail e siga as instruções para ativá-lo.");
        this.router.navigate(['/login']);
      },
      err => {
        this.showSpinner = false;
        if (err.status === 406) {
          this.error = true;
        }
        this.utilService.showError(err.message);
      }
    );
  }

  reenviarEmail() {
    this.usuario.urlAcesso = this.utilService.getSubdominio();
    
    this.usuarioService.reenviarEmail(this.usuario).subscribe(
      () => {
        this.loginService.logout();
        this.utilService.showSuccess("E-mail reenviado com sucesso. Verifique seu e-mail e siga as instruções para ativá-lo.");
      },
      err => {
        this.utilService.showError(err.message);
      }
    );
  }

  lowerCase(email: string) {
    if (email !== undefined)
      this.usuario.email = email.toLowerCase();
  }

  cancel() {
    this.location.back();
  }

  getError(error) {
    if (error.status === 401 || error.status === 403) {
      this.loginService.logout();
    } else {
      let err;

      if (error.status === 0) {
        err = 'Servidor indisponível!';
      } else {
        err = error.message || error;
      }
      this.utilService.showError(err);
    }
  }

  resolved(captchaResponse: string) {
    this.captchaValue = captchaResponse;
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }
}
